import React, { Component } from 'react';
import classNames from 'classnames';
import ReactDataGrid from 'react-data-grid';
import ReactDOM from 'react-dom';
import { Toolbar, Data, Editors, Formatters } from 'react-data-grid-addons';
import _ from 'lodash';
import moment from 'moment';
import { Grid, Row, Col, Panel, Button, DropdownButton, ButtonToolbar, MenuItem, FieldGroup, Input,  Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router';
import { Translate, Localize, I18n } from 'react-redux-i18n';
import { Field, FieldArray, reset } from 'redux-form';
import { SkyLightStateless } from 'react-skylight';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Selection from '../Common/selection';
import CashFormatter from '../Common/cashFormatter';
import { InputField, DisabledInputField, ControlledInputField } from '../Common/inputField';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import SalesInventoryInfo from '../../containers/Sales/salesInventoryInfo';
import ReturnModal from '../../containers/Returns/returnModal';
import SetWeightModal from '../../containers/Dispatch/setWeightModal';
import IssueCreditAutoSuggest from './components/IssueCreditAutoSuggest';
import ItemHistoryGrid from '../../components/Common/itemHistoryGrid';
import Spinner from '../../components/Widgets/spinner';
import { isGGI, isOCM, isOLG, isSDR, isCRW, isDAICHEONG } from '../../actions/root_url';
import { numberWithCommas} from '../Common/numberWithCommas'

const DropDownEditor = Editors.DropDownEditor;

const DateFormatter = React.createClass({
  render() {
    if (this.props.value) {
      let year = this.props.value.split('/')[2];
      if (year) {
        year = year.substring(2);
      }
      let date = this.props.value.split('/')[0] + '/' + this.props.value.split('/')[1] + '/' + year;
      return <span>{date}</span>;
    }
    return <span className="label label-danger">-</span>;
  },
});

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

class CustomerIssueCredit extends Component{
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton - 150,

      invoice: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      totalPrice: 0,
      oldQty: 0,
      showInventoryOpen: false,
      currentCustomer_id: null,
      selectedInventoryRow: {},
      curRow: '',
      curTotal: 0,
      curCRV: 0,
      curTax: 0,
      curRestock: 0,
      curRestockP: 0,
      curNotation: '',
      curFinal: 0,
      totalLoaded: null,
      ReturnFormatter: false,
      IsWeight: false,
      rowChosen: null,
      currentWeights: null,
      backLogWeights: [],
      suggestValue: '',
      salesItemHistory: [],
      defaultSalesName: '',
    };
    this.handleResize = this.handleResize.bind(this);
  }

  componentWillMount() {
    if (!this.props.currentCustomer) {
      this.context.router.push('/customerReturn/');
    } else {
      this.setState({ currentCustomer_id: this.props.currentCustomer.id });
    }
    this.props.setDefaultSearchType('RefNum', 'customerIssueCredit');
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    const { currentSalesInvoice } = this.props;

    if(this.props.currentCustomer) {
      this.props.fetchCustomerDetail(this.props.currentCustomer.id);
      this.props.fetchTaxRates(null, this.props.selectedCompany ? this.props.selectedCompany.value : '');
    }
    // else if(typeof currentSalesInvoice == "object" && currentSalesInvoice && currentSalesInvoice.SalesReturn_id != null){
    //   this.props.fetchSalesReturnDetail(currentSalesInvoice.SalesReturn_id);
    // }
    // else if(typeof currentSalesInvoice == "object" && currentSalesInvoice)
    //   this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice.SalesInvoice_id);
    // else if(currentSalesInvoice)
    //   this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice, "InvoiceNum");
    // this.props.fetchSalesInvoice("1900-01-01", "3000-01-01", null, 7);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.salesInvoiceDetail && nextProps.salesInvoiceDetail != this.props.salesInvoiceDetail) {
      let invoice = { ...this.state.invoice, rows: nextProps.salesInvoiceDetail.Sales_Invoice_Lines || []};
      this.setState({ invoice });
      if(isGGI) {
        if(nextProps.salesInvoiceDetail.DefaultSalesName) {
          this.setState({defaultSalesName:nextProps.salesInvoiceDetail.DefaultSalesName})
          this.props.setValue('customerIssueCredit', 'Sales_User_id', nextProps.salesInvoiceDetail.Sales_User_id);
        }
      }
    }
    if (nextProps.taxRates && nextProps.taxRates != this.props.taxRates) {
      let invoice = { ...this.state.invoice, TaxRate: nextProps.taxRates.length >= 1 && nextProps.taxRates[0].Rate || 0};
      this.setState({ invoice });
    }
    if (nextProps.selectedCompany && nextProps.selectedCompany.value !== this.props.selectedCompany.value) {
      this.props.fetchTaxRates(null, nextProps.selectedCompany.value);
    }
    if(nextProps.salesItemHistory) {
      this.setState({
        salesItemHistory: nextProps.salesItemHistory
      })
    }
  }

  handleResize(e) {
    this.setState({tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton - 150});
  }

  handleOnFocus = (event) => {
    event.target.select();
  }

  setAllProductQuantity = (quantity) => {
    this.props.setValue('salesOrderForm', 'Quantity', quantity);
  }

  selectInventoryInfo = (selectedInventoryRow) => {
    this.setState({
      selectedInventoryRow,
      inStock: selectedInventoryRow.InStock,
      purchased: selectedInventoryRow.Purchased,
      presale: selectedInventoryRow.PreSale,
      net_weight: selectedInventoryRow.NetWeight,
      ship_weight: selectedInventoryRow.NetWeight,
      product_type: selectedInventoryRow.ProductType
    }, () => {
      this.props.setValue('customerIssueCredit', 'Weight', selectedInventoryRow.NetWeight);
        this.props.setValue('customerIssueCredit', 'SmallUnitPrice', selectedInventoryRow.SmallUnitPrice);
        this.props.setValue('customerIssueCredit', 'ConvertNum', selectedInventoryRow.ConvertNum);
      this.handleAfterShowInventoryClose('quantity');
    });
  }

  openShowInventory(event) {
    if (!this.props.searchValue || this.props.searchValue === '') {
      return;
    }
    switch (event.charCode) {
      case 13: // ENTER
        event.preventDefault();
        if (this.props.currentCustomer) {
          this.setState({ showInventoryOpen: true });
          break;
        } else {
          this.setState({ case: 'noCustomerChosen', confirmOpen: true });
          break;
        }
      default:
        break;
    }
  }
  closeShowInventory = (value) => {
    this.handleAfterShowInventoryClose(value);
    this.setState({ showInventoryOpen: false });
  }

  handleAfterShowInventoryClose(value) {
    ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
  }

  handleKeyPress(value, event){
    if(event.charCode == 13){
      event.preventDefault();
      if((isGGI && value == 'smallUnitPrice') || value == 'unitPrice' || value == 'notation') {
        if (!isNumeric(this.props.Quantity) ||  this.props.Quantity < 0){
          return;
        }
      }
      ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
    }
  }

  moveToIssueForm = () => {
    let invoice = this.state.invoice;
    const {
      CRV,
      ProductNum,
      Name,
      Description,
      isTaxable,
      MeasureUnit,
      NetWeight,
      PackageSize,
      PackageType,
      ProductType,
      Product_id,
      RefNum,
      RefPrice,
    } = this.state.selectedInventoryRow;
    const {
      UnitPrice,
      Quantity,
      Weight,
      SmallUnitPrice,
      ConvertNum
    } = this.props;

    let Total = 0;
    if (ProductType === "Fixed" || ProductType === 'Non-Product') {
      if (Quantity) {
        if(isGGI) {
          Total = +roundTo(Quantity * SmallUnitPrice * ConvertNum, 2).toFixed(2)
        } else {
          Total = +roundTo((Quantity * UnitPrice), 2).toFixed(2)
        }
      }
    } else {
      if (Weight) {
        if(isGGI) {
          Total = +roundTo(Quantity * SmallUnitPrice * Weight, 2).toFixed(2)
        } else {
          Total = +roundTo((Quantity * UnitPrice * Weight), 2).toFixed(2)
        }
      }
    }
    if (isNaN(Total)) {
      Total = 0;
    }
    let newWeightsList = [];
    for (let i = 0; i < Quantity && ProductType !== "Fixed" && ProductType !== 'Non-Product'; i++)
      newWeightsList.push(parseFloat(Weight));
    let newEntry = {
      Idx: (invoice.rows.length) ? invoice.rows[invoice.rows.length - 1].Idx + 1 : 0,
      CRV,
      ProductNum,
      Name,
      Description,
      isTaxable,
      MeasureUnit,
      NetWeight,
      PackageSize,
      PackageType,
      ProductType,
      Product_id,
      RefNum,
      RefPrice,
      UnitPrice,
      ReturnableWeightsList: newWeightsList,
      Weights: newWeightsList,
      LoadedQuantity: parseFloat(Quantity),
      TotalNetWeight: parseFloat(Weight) * parseFloat(Quantity),
      ReturnQuantity: parseFloat(Quantity),
      ReturnWeight: parseFloat(Weight) * parseFloat(Quantity),
      ReturnTotalPrice: Total,
      ReturnReason: "",
      IsProductReturned: false,
    };
    
    if(isGGI) {
      newEntry.SmallUnitPrice = SmallUnitPrice;
      newEntry.UnitPrice = (SmallUnitPrice * ConvertNum).toFixed(4);
      newEntry.ConvertNum = ConvertNum;
    }
    invoice.rows.push(newEntry);
    this.setState({invoice});
    this.props.resetIssueInputs();
    this.onProductAdded()
  }

  onProductAdded = () => {
    this.setState({
      suggestValue: '',
    }, () => {
      const suggestInput = document.getElementById('issue-credit-auto-suggest');
      suggestInput.focus();
      suggestInput.select();
    })
  }

  renderSubtotal() {
    let subtotal = 0;
    if (this.state.selectedInventoryRow.ProductType === "Fixed" || this.state.selectedInventoryRow.ProductType === 'Non-Product') {
      if (this.props.Quantity) {
        if(isGGI) {
          subtotal = (this.props.Quantity * this.props.SmallUnitPrice * this.props.ConvertNum).toFixed(2)
        } else {
          subtotal = (this.props.Quantity * this.props.UnitPrice).toFixed(2)
        }
      }
    } else {
      if (this.props.Weight) {
        if(isGGI) {
          subtotal = (this.props.Quantity * this.props.SmallUnitPrice * this.props.Weight).toFixed(2)
        } else {
          subtotal = (this.props.UnitPrice * this.props.Weight).toFixed(2)
        }
      }
    }
    if (isNaN(subtotal)) {
      subtotal = 0;
    }
    return (
      <Field  name="Subtotal" component={DisabledInputField} placeholder={subtotal}/>
    )
  }

  formatDate(date) {
    let formattedDate = date.getFullYear() + '-';
    formattedDate += date.getMonth()+1 + '-';
    if (date.getDate() < 10) {
      formattedDate += '0' + date.getDate();
    } else {
      formattedDate += date.getDate();
    }
    return formattedDate;
  }

  calculateFinalTotal(nextProps) {
    let Tax = nextProps.Tax;
    let Promo = nextProps.Promo;
    let RestockingFee = nextProps.RestockingFee;

    if (isNumeric(Tax)) {
      Tax = parseFloat(Tax);
    } else {
      Tax = 0;
    }
    if (isNumeric(Promo)) {
      Promo = parseFloat(Promo);
    } else {
      Promo = 0;
    }
    if (isNumeric(RestockingFee)) {
      RestockingFee = parseFloat(RestockingFee);
    } else {
      RestockingFee = 0;
    }
    return Tax + Promo - RestockingFee;
  }

  closeReturnModal = () => { this.setState({ ReturnModalOpen: false, IsWeight: false}); }

  openWeightModule = () => { this.setState({ ReturnModalOpen: true, IsWeight: true }); }
  openQuantityModule = () => { this.setState({ ReturnModalOpen: true, IsWeight: false}); }

  setWeights = (currentRow, currentWeights, editedRow) => {
    let index = 0;
    let Weights = [];
    let ReturnWeight = 0;
    currentWeights.map(row => {
      Weights.push( parseFloat(roundTo(parseFloat(row.Weight), 2).toFixed(2)) );
      ReturnWeight += roundTo(parseFloat(row.Weight), 2);
    });
    const rows = [...this.state.invoice.rows];
    rows[currentRow].Weights = Weights;
    rows[currentRow].ReturnableWeightsList = Weights;
    rows[currentRow].ReturnWeight = roundTo(parseFloat(ReturnWeight), 2);
    
    if(isGGI) {
      rows[currentRow].ReturnTotalPrice = parseFloat(roundTo(parseFloat(ReturnWeight) * rows[currentRow].SmallUnitPrice, 2)).toFixed(2);
      rows[currentRow].UnitPrice = parseFloat(roundTo(parseFloat(ReturnWeight/rows[currentRow].ReturnQuantity) * rows[currentRow].SmallUnitPrice, 2)).toFixed(2);
    } else {
      rows[currentRow].ReturnTotalPrice = parseFloat(roundTo(parseFloat(ReturnWeight) * rows[currentRow].UnitPrice, 2)).toFixed(2);
    }
    const invoice = { ...this.state.invoice, rows };
    this.setState({ invoice });
  }

  keepLoaded = (oldLoaded) => {
    let invoice = {...this.state.invoice};
    invoice.rows[this.state.currentRow].ReturnQuantity = oldLoaded;
    this.setState({ invoice });
  }

  returnTotalWeight(totalWeight) {
    console.log("this is the return weight", totalWeight);
  }

    renderInvoice() {
      let that = this;
      if (this.props.isLoading && !this.props.error) return <Spinner/>
      else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
      else {
        // Parameters of the react-data-grid
        const getRows = () => {
          return Data.Selectors.getRows(this.state.invoice);
        }

        const getSize = () => { return getRows().length; }

        const rowGetter = rowIdx => {
          var rows = getRows();
          return rows[rowIdx];
        }

        // Handle the sortable function
        const handleGridSort = (sortColumn, sortDirection) => {
          var invoice = {...this.state.invoice, sortColumn: sortColumn, sortDirection: sortDirection};
          this.setState({ invoice });
        }

        const handleRowUpdated = (e) => {
          let rows = getRows();//this.state.invoice.rows;
          let oldQty = parseFloat(rows[e.rowIdx].ReturnQuantity) || 0;
          Object.assign(rows[e.rowIdx], e.updated);
          if (e.cellKey === "ReturnQuantity" && (this.state.invoice.rows[e.rowIdx].ProductType === 'Fixed' || this.state.invoice.rows[e.rowIdx].ProductType === 'Per-Pound' || this.state.invoice.rows[e.rowIdx].ProductType === 'Non-Product')){
            let invoice = {...this.state.invoice};
            if (invoice.rows[e.rowIdx].LoadedQuantity)
              invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(e.updated.ReturnQuantity);
            if(parseFloat(e.updated.ReturnQuantity) < 0)
              invoice.rows[e.rowIdx].ReturnQuantity = 0;
            invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(invoice.rows[e.rowIdx].ReturnQuantity);
            invoice.rows[e.rowIdx].ReturnWeight = (invoice.rows[e.rowIdx].LoadedQuantity) ?
                ((invoice.rows[e.rowIdx].TotalNetWeight/invoice.rows[e.rowIdx].LoadedQuantity) * invoice.rows[e.rowIdx].ReturnQuantity) :
                ((invoice.rows[e.rowIdx].InvoiceWeight/invoice.rows[e.rowIdx].InvoiceQuantity) * invoice.rows[e.rowIdx].ReturnQuantity);
            invoice.rows[e.rowIdx].ReturnWeight = +roundTo(invoice.rows[e.rowIdx].ReturnWeight, 2).toFixed(2);
            
            if (this.state.invoice.rows[e.rowIdx].ProductType === 'Fixed' || this.state.invoice.rows[e.rowIdx].ProductType === 'Non-Product') {
              if(isGGI) {
                invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].SmallUnitPrice * invoice.rows[e.rowIdx].ConvertNum, 2)).toFixed(2);
              } else {
                invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
              }
            }
              
            else {
              if(isGGI) {
                invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnWeight * invoice.rows[e.rowIdx].SmallUnitPrice, 2)).toFixed(2);
                invoice.rows[e.rowIdx].UnitPrice = ((invoice.rows[e.rowIdx].ReturnWeight / invoice.rows[e.rowIdx].ReturnQuantity) * invoice.rows[e.rowIdx].SmallUnitPrice);
              } else {
                invoice.rows[e.rowIdx].ReturnTotalPrice = (invoice.rows[e.rowIdx].ReturnWeight * invoice.rows[e.rowIdx].UnitPrice);
              }
            }
              
            invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnTotalPrice, 2)).toFixed(2);
            invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo((invoice.rows[e.rowIdx].CRV / invoice.rows[e.rowIdx].LoadedQuantity) * parseFloat(e.updated.ReturnQuantity), 2)).toFixed(2);
            this.setState({ invoice, totalLoaded: invoice.rows[e.rowIdx].LoadedQuantity});
          } else if (e.cellKey == "ReturnQuantity" && this.state.invoice.rows[e.rowIdx].ProductType === 'Non-Fixed'){
            let updated = {...e.updated};
            if (parseFloat(updated.ReturnQuantity) < 0)
              updated.ReturnQuantity = 0;
            Object.assign(rows[e.rowIdx], updated);
            this.setState({currentRow: e.rowIdx, totalLoaded: parseFloat(rows[e.rowIdx].ReturnQuantity), rowChosen: e.rowIdx, currentWeights: rows[e.rowIdx].Weights, editedRow: rows[e.rowIdx], oldQty});
            this.openWeightModule();
          }
          if (e.cellKey === 'UnitPrice') {
            let invoice = {...this.state.invoice};
            // Update Return Total Price
            invoice.rows[e.rowIdx].UnitPrice = +parseFloat(roundTo(rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
            if (this.state.invoice.rows[e.rowIdx].ProductType === 'Fixed' || this.state.invoice.rows[e.rowIdx].ProductType === 'Non-Product') {
              invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
            } else {
              invoice.rows[e.rowIdx].ReturnTotalPrice = (invoice.rows[e.rowIdx].ReturnWeight * invoice.rows[e.rowIdx].UnitPrice);
            }
            this.setState({ invoice });
          }
          if(e.cellKey == "ReturnReason"){
            let invoice = {...this.state.invoice};
            invoice.rows[e.rowIdx].ReturnReason = e.updated.ReturnReason;
            this.setState({ invoice });
          }
          if(isGGI && e.cellKey == "SmallUnitPrice") {
            let invoice = {...this.state.invoice};
            // Update Return Total Price
            
            if (this.state.invoice.rows[e.rowIdx].ProductType === 'Fixed' || this.state.invoice.rows[e.rowIdx].ProductType === 'Non-Product') {
              invoice.rows[e.rowIdx].UnitPrice = +parseFloat(invoice.rows[e.rowIdx].SmallUnitPrice * invoice.rows[e.rowIdx].ConvertNum);
              invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
            } else {
              invoice.rows[e.rowIdx].UnitPrice = +parseFloat(invoice.rows[e.rowIdx].SmallUnitPrice * (invoice.rows[e.rowIdx].ReturnWeight/invoice.rows[e.rowIdx].ReturnQuantity));
              invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnWeight * invoice.rows[e.rowIdx].SmallUnitPrice, 2)).toFixed(2);
            }
            this.setState({ invoice });
          }
        }

        // const returnReasonOptions = [
        //   'Damaged',
        //   'Defective',
        //   'Not Needed',
        //   'Repair',
        //   'Wrong Item',
        //   'Other',
        //   'Missing',
        //   'Out',
        //   'Short',
        // ];
        var returnReasonOptions = [
          { id: 0, title: 'Damaged', value: 'Damaged', text: 'Damaged' },
          { id: 1, title: 'Defective', value: 'Defective', text: 'Defective' },
          { id: 2, title: 'Not Needed', value: 'Not Needed', text: 'Not Needed' },
          { id: 3, title: 'Repair', value: 'Repair', text: 'Repair' },
          { id: 4, title: 'Wrong Item', value: 'Wrong Item', text: 'Wrong Item' },
          { id: 5, title: 'Other', value: 'Other', text: 'Other' },
          { id: 6, title: 'Missing', value: 'Missing', text: 'Missing' },
          { id: 7, title: 'Out', value: 'Out', text: 'Out' },
          { id: 8, title: 'Short', value: 'Short', text: 'Short' },
        ];

        if (isDAICHEONG) {
          returnReasonOptions = [
            { id: 0, title: 'Damaged&Defective', value: 'Damaged&Defective', text: 'Damaged&Defective' },
            { id: 1, title: 'Missing&Short', value: 'Missing&Short', text: 'Missing&Short' },
            { id: 2, title: 'Not Needed', value: 'Not Needed', text: 'Not Needed' },
            { id: 3, title: 'Wrong Item', value: 'Wrong Item', text: 'Wrong Item' },
            { id: 4, title: 'Expired', value: 'Expired', text: 'Expired' },
            { id: 5, title: 'Pallet', value: 'Pallet', text: 'Pallet' },
            { id: 6, title: 'CRV', value: 'CRV', text: 'CRV' },
            { id: 7, title: 'Restock', value: 'Restock', text: 'Restock' },
            { id: 8, title: 'Other', value: 'Other', text: 'Other' },
          ];
        }

        // const ReasonEditor = <AutoCompleteEditor options={returnReasonOptions} />;
        const deleteFormatter = React.createClass({
          render() {
            return(
              <span>
                <Button
                bsStyle="danger"
                className="textAlignStyle"
                onClick={() => {
                let invoice = {...that.state.invoice};
                let index = 0;
                for (let i = 0; i < invoice.rows.length; i++){
                  if (this.props.dependentValues.Idx === invoice.rows[i].Idx){
                    index = i;
                  }
                }
                invoice.rows.splice(index, 1);
                that.setState({invoice});
              }}>X</Button>
            </span>);
          }
      });

      const onRowClick = (rowIdx, row) => {
        if (rowIdx > -1) {
          this.props.fetchItemSalesHistory(this.state.currentCustomer_id, row.Product_id, true);
        }
      };
          
      const onRowsSelected = (rows) => {
        let newRows = this.state.invoice.rows;
        // for (let i = 0; i < newRows.length; i++) {
        //    newRows[i].isSelected = false;
        // }
        let curRow = false;
        rows.map (r => {
          newRows[r.rowIdx].isSelected = true;
          if (!newRows[r.rowIdx].Restock)
            newRows[r.rowIdx].Restock = 0;
        });
        let selectedRows = [...this.state.invoice.selectedRows];
        selectedRows = selectedRows.concat(rows.map(r => r.row));
        let invoice = {...this.state.invoice, rows: newRows, selectedRows: selectedRows};
        this.setState({
          invoice
        });
      }

      const onRowsDeselected = (rows) => {
        let newRows = this.state.invoice.rows;
        rows.map (r => {
          newRows[r.rowIdx].isSelected = false;
        });
        let selectedRows = [...this.state.invoice.selectedRows];
        selectedRows = selectedRows.filter(function(obj){
           return obj.isSelected == true;
        })
        let invoice = {...this.state.invoice, rows: newRows, selectedRows: selectedRows};
        this.setState({
          invoice
        });
      }
      // let reasonEditor = <DropDownEditor options={returnReasonOptions} />;
      // let reasonFormattor = <DropDownFormatter options={returnReasonOptions} value='bug' />;

      const IsFixedFormatter = React.createClass({
        render() {
          if (this.props.dependentValues.ProductType === "Non-Fixed") {
            return <span>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
          } else if (this.props.dependentValues.ProductType === "Per-Pound"){
            return <span>{this.props.value} <label className="label label-primary"><Translate value="per_pound" /></label></span>;
          } else {
            return <span>{this.props.value}</span>;
          }
        }
      });

      const ReturnWeightFormatter = React.createClass({
        render() {
          return (<span>{(this.props.dependentValues.ReturnWeight || this.props.dependentValues.ReturnWeight === 0) ? this.props.dependentValues.ReturnWeight : ''}</span>);
        }
      });

      const StatusFormatter =  React.createClass({
        render() {
          return (<span style={{width: "100%"}}><input type="checkbox" checked={this.props.dependentValues.IsProductReturned} onClick={() => { that.handleProductChange(this.props.dependentValues); }} /></span>);
        }
      });

      const ReturnFormatter = React.createClass({
        render() {
          if(this.props.dependentValues)
            return(this.props.dependentValues.ProductType === 'Fixed') ?
              <span style={{'padding-right':'5px'}}>{(this.props.dependentValues.ReturnQuantity)}{' '}<Button
              bsStyle="warning"
              className="textAlignStyle" style={{ height: '20px', width: '60px', padding: '0px' }}
              disabled={!this.props.dependentValues.isSelected}
              onClick={() => {
                /*var ProductNum = this.props.dependentValues.ProductNum;
                that.removeRow(ProductNum);*/
                let currentWeights = {};
                currentWeights.Weights = [...this.props.dependentValues.ReturnWeightsList, ...this.props.dependentValues.ReturnableWeightsList];
                
                that.setState({ rowChosen: this.props.dependentValues.SalesInvoiceLine_id, currentWeights});
                that.openWeightModule(this.props.dependentValues);
              }}><Translate value="change" /></Button></span> :
              <span>{(this.props.dependentValues.ReturnQuantity || this.props.dependentValues.ReturnQuantity === 0) ? this.props.dependentValues.ReturnQuantity : ''}</span>;
          }
      });

      const TotalPriceFormatter = React.createClass({
        render() {
          return (
            (that.props.params.id) ?
              <span>{(this.props.dependentValues.ProductType === 'Fixed') ?
                parseFloat(roundTo(this.props.dependentValues.ReturnQuantity * this.props.dependentValues.UnitPrice, 2)).toFixed(2) :
                parseFloat(roundTo(this.props.dependentValues.ReturnWeight * this.props.dependentValues.UnitPrice, 2)).toFixed(2)
              }</span> :
              <span>{this.props.dependentValues.TotalPrice}</span>
          );
        }
      });


      const GGIPriceFormatter = React.createClass({
        render() {
          const { value, className, style } = this.props;
          return <span className={className} style={style}>{ (value !== null && !isNaN(value) && `$${numberWithCommas(parseFloat(value).toFixed(2))}`) }</span>;
        }
      });
      const columns =[{
          key: 'Delete',
          name: <Translate value="del" />,
          width: 40,
          formatter: deleteFormatter,
          getRowMetaData: (row) => row
        },
        ...isOLG ? [{
          key: 'RefNum',
          name: <Translate value="item_no" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true
        }] : [{
          key: 'ProductNum',
          name: <Translate value="product_num" />,
          resizable: true,
          sortable: true,
          width: 140,
          filterable: true
        }],
        {
          key: 'Name',
          name: <Translate value="name" />,
          resizable: true,
          sortable: true,
          width: 140,
          filterable: true,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 160,
          filterable: true,
        },
        {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          editable: !isGGI,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: isGGI ? GGIPriceFormatter : CashFormatter,
        },
        {
          key: 'ReturnQuantity',
          name: <Translate value="return_qty" />,
          resizable: true,
          sortable: true,
          editable: true,
          width: 130,
          filterable: true,
          formatter: IsFixedFormatter,
          getRowMetaData: (row) => row,
        },
        {
          key: 'ReturnWeight',
          name: <Translate value="rtn_wt" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          formatter: ReturnWeightFormatter,
          getRowMetaData: (row) => row,
        },
        {
          key: 'ReturnTotalPrice',
          name: <Translate value="total_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: isGGI ? GGIPriceFormatter : CashFormatter,
        },
        {
          key: 'ReturnReason',
          name: <Translate value="return_reason" />,
          resizable: true,
          sortable: true,
          // editor: ReasonEditor,
          editor: <DropDownEditor options={returnReasonOptions}/>,

        },
        {
          key: 'IsProductReturned',
          name: <Translate value="is_prod_rtnd" />,
          resizable: true,
          sortable: true,
          formatter: StatusFormatter,
          getRowMetaData: (row) => row,
        },
      ];
      if(isGGI) {
        const unitPriceIdx = _.findIndex(columns, { key: "UnitPrice" });
        const smallPrice = {
          key: "SmallUnitPrice",
          name: <Translate value="small_unit_price" />,
          resizable: true,
          width: 120,
          sortable: true,
          editable: true,
        };
      
        columns.splice(unitPriceIdx, 0, smallPrice);
      }

      return (
        <Row>
          <Col sm={ 12 }>
            <div id="CustomerIssueCredit-dataGrid1">
              <ReactDataGrid
                rowKey='Product_id'
                onGridSort={handleGridSort}
                columns={columns}
                rowHeight={25}
                rowGetter={rowGetter}
                rowsCount={getSize() }
                onRowUpdated={handleRowUpdated}
                minHeight={this.state.tableHeight}
                onGridRowsUpdate={()=>{console.log("grid row updating")}}
                //enableRowSelect={true}
                enableCellSelect={true}
                onRowClick={onRowClick}
                // rowSelection={{
                //   showCheckbox: true,
                //   onRowsSelected: onRowsSelected,
                //   onRowsDeselected: onRowsDeselected,
                //   selectBy: {
                //     isSelectedKey: 'isSelected'
                //   }
                // }}
              />
            </div>
          </Col>
        </Row>
      )
    }
  }

  checkValues = (selected) => {
    for(let i = 0; i < selected.length; i++){
      if (!selected[i].ReturnQuantity || selected[i].ReturnQuantity === null || selected[i].ReturnQuantity === 0){
        alert("Quantity cannot be zero or blank, if you want to remove a row please deselect it");
        return false;
      }
    }
    return true;
  }

  handleIssue = (TotalPrice, TaxRate, Tax, CRV, RestockingFee, RestockingFeePercentage, FinalPrice, Notation, Sales_User_id) => {
    let ReturnStatus = false;
    for(let i = 0; i < this.state.invoice.rows.length; i++){
      if(!this.state.invoice.rows[i].ReturnReason){
        ReturnStatus = true;
        i = this.state.invoice.rows.length;
      }
    }
    if (!ReturnStatus)
      this.props.createCreditIssue(
        this.props.currentCustomer.id,
        TotalPrice,
        TaxRate,
        Tax,
        CRV,
        RestockingFee,
        RestockingFeePercentage,
        FinalPrice,
        Notation,
        this.state.invoice,
        this.props.PostingDate,
        this.props.selectedWarehouse,
        Sales_User_id,
      )
    else
      alert('Please specify a Return Reason(s) for issuing credit');
  }

  handleProductChange = (row) => {
    let invoice = {...this.state.invoice};
    for (let i = 0; i < invoice.rows.length; i++){
      if (invoice.rows[i].Idx === row.Idx) {
        invoice.rows[i].IsProductReturned = !invoice.rows[i].IsProductReturned;
      }
    }
    this.setState({invoice});
  }


  // handleRestock = (e) =>{
  //   if (typeof parseFloat(e.target.value, 10) !== 'NaN' && (e.target.value !== '')) {
  //     let curRestock = e.target.value;
  //     let invoice = {...this.state.invoice};
  //     this.setState({curRestock, invoice});
  //   } else if (e.target.value === ''){
  //     this.setState({curRestock: '' });
  //   }
  // }

  handleRestock = (e) => {
    if (typeof parseFloat(e.target.value, 10) !== 'NaN' && (e.target.value !== '')) {
      const curRestock = e.target.value;
      const invoice = { ...this.state.invoice };
      let curRestockP = 0;
      let total = 0

      for (let i = 0; i < invoice.rows.length; i++) {
        total += invoice.rows[i].ReturnTotalPrice ? Number(invoice.rows[i].ReturnTotalPrice) : 0;
      }
      curRestockP = curRestock ? (Number(curRestock)*100)/total : 0;
      curRestockP = curRestockP.toFixed(2);

      this.setState({ curRestock, curRestockP, invoice });
    } else if (e.target.value === '') {
      this.setState({ curRestock: '', curRestockP: '' });
    }
  }

  handleRestockP = (e) => {
    if (typeof parseFloat(e.target.value, 10) !== 'NaN' && (e.target.value !== '')) {
      let curRestock = 0;
      const curRestockP = e.target.value;
      const invoice = { ...this.state.invoice };

      for (let i = 0; i < invoice.rows.length; i++) {
        curRestock += invoice.rows[i].ReturnTotalPrice ? Number(invoice.rows[i].ReturnTotalPrice)*(Number(curRestockP)/100) : 0;
      }
      curRestock = curRestock.toFixed(2);

      this.setState({ curRestockP, curRestock, invoice });
    } else if (e.target.value === '') {
      this.setState({ curRestockP: '', curRestock: '' });
    }
  }

  handleNotation = (e) =>{
    this.setState({curNotation: e.target.value});
  }

  getUsers = () => {
    const Users = [];
    this.props.users.map((user) => {
      Users.push({ value: user.user_id, label: user.FirstName });
    });
    return Users;
  }

  renderGGISales(salesInvoiceDetail) {
    const Users = this.getUsers();
    if(isGGI && (salesInvoiceDetail == null || salesInvoiceDetail && (salesInvoiceDetail.InvoiceNum == undefined || salesInvoiceDetail.InvoiceNum== null))) {
       return <Row>
       <Col xs={2}>
         <label><Translate value="sales" />:</label>
       </Col>
       <Col xs={7}>
        <Field name="Sales_User_id" component={Selection} options={Users} defaultPlaceHolder={this.state.defaultSalesName}/>
       </Col>
   </Row>
    } else {
      return<Row>
        <Col xs={2}>
          <label><Translate value="sales" />:</label>
        </Col>
        <Col xs={7}>
          {salesInvoiceDetail && salesInvoiceDetail.Sales_User_Name}
        </Col>
    </Row>
    }
  }
    
  renderItemHistory() {
    const columns = [
      {
        key: 'Quantity',
        name: <Translate value="qty" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 40,
      },
      {
        key: 'UnitPrice',
        name: <Translate value="so_dollarsign" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 50,
      },
      {
        key: 'SIUnitPrice',
        name: <Translate value="si_dollarsign" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 50,
      },
      {
        key: 'Date',
        name: <Translate value="date" />,
        resizable: true,
        sortable: true,
        width: 85,
        formatter: DateFormatter,
      },
    ];

    return (
      <ItemHistoryGrid
        columns={columns}
        rowHeight={25}
        minHeight={130}
      />
    );
  }

  renderUnitPrice = () => {
    if(isGGI) {
      return <Col xs={ 2 } className="pr0">
        <label ><Translate value="small_pr" /><span className="dollar-sign">$$</span></label>
        <Field name="SmallUnitPrice" withRef={true} ref="smallUnitPrice" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
        if (event.charCode == 13) {
          if (!isNumeric(this.props.Quantity) || this.props.Quantity < 0 || !isNumeric(this.props.SmallUnitPrice) || this.props.SmallUnitPrice < 0){
            return;
          }
          // this.handleKeyPress('productSearch', event);
          this.moveToIssueForm();
        }
        }}/>
        </Col>
    } else {
      return <Col xs={ 2 } className="pr0">
                  <label ><Translate value="unit" /><span className="dollar-sign">$$</span></label>
                  <Field name="UnitPrice" withRef={true} ref="unitPrice" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                      if (event.charCode == 13) {
                        if (!isNumeric(this.props.Quantity) || this.props.Quantity < 0 || !isNumeric(this.props.UnitPrice) || this.props.UnitPrice < 0){
                          return;
                        }
                        // this.handleKeyPress('productSearch', event);
                        this.moveToIssueForm();
                      }
                  }}/>
             </Col>
    }
  }

  render() {
    let createDialogInventoryStyle = {
      height: '700px',
      width: '1000px',
      marginLeft: '-28%',
      marginTop: '-20%',
    };
    let createDialogStyleWeight = {
      width: '500px',
      height: '600px',
      top: '45%',
      marginLeft: '-10%',
    };
    const selectInventoryInformation = (<Translate value="select_inventory_information" />);
    const salesInvoiceDetail = (!this.props.params.id) ? this.props.salesInvoiceDetail : this.props.salesReturnDetail;
    if (this.props.salesReturnDetail && this.props.salesReturnDetail.SRNum)
      salesInvoiceDetail.InvoiceNum = (this.props.params.id) ? this.props.salesReturnDetail.SRNum.slice(0, -1) : salesInvoiceDetail.InvoiceNum;
    const { handleSubmit } = this.props;
    let Customer_Name = '';
    if (salesInvoiceDetail) {
      Customer_Name = (salesInvoiceDetail.Name) ? salesInvoiceDetail.Name : salesInvoiceDetail.Deliver_Customer_Name;
    }
    let taxRate = 0;
    let tax = 0;
    let total = 0;
    let CRV = 0;
    let finalPrice = 0;
    taxRate = parseFloat(this.state.invoice.TaxRate) || 0;
    for(let i = 0; i < this.state.invoice.rows.length; i++){
      total += (this.state.invoice.rows[i].ReturnTotalPrice) ? roundTo(parseFloat(this.state.invoice.rows[i].ReturnTotalPrice), 2) : 0;
      if (this.state.invoice.rows[i].isTaxable && this.state.invoice.rows[i].ReturnTotalPrice)
        tax += (this.state.invoice.rows[i].ReturnTotalPrice) ? roundTo(parseFloat(this.state.invoice.rows[i].ReturnTotalPrice), 2) : 0;
      CRV += +roundTo(parseFloat(this.state.invoice.rows[i].CRV || 0) * (parseFloat(this.state.invoice.rows[i].ReturnQuantity) || 0), 2).toFixed(2);
    }
    tax = tax*(parseFloat(taxRate || 0) / 100.0);
    tax = parseFloat(roundTo(tax, 2)).toFixed(2);
    total = parseFloat(roundTo(total, 2)).toFixed(2);
    CRV = parseFloat(roundTo(CRV, 2)).toFixed(2);
    finalPrice = parseFloat(roundTo((parseFloat(total) || 0) + (parseFloat(CRV) || 0) + (parseFloat(tax) || 0) - (parseFloat(this.state.curRestock) || 0), 2)).toFixed(2);
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="returns" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="issue_credit" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <ButtonToolbar id="breadcrumbButtonGroup">
          <Button
            bsStyle="success"
            disabled={this.state.invoice.rows.length === 0}
            onClick={()=>{ this.handleIssue(total, taxRate, tax, CRV, this.state.curRestock, this.state.curRestockP, finalPrice, this.state.curNotation, this.props.SalesID); }} >
              <span><em className="fa fa-check" /><Translate value="issue_credit" /></span>
          </Button>
          <Button
            bsStyle="danger"
            type="button"
            onClick={() => { this.context.router.push('/customerReturn') }}>
            <em className="fa fa-close"/><Translate value="exit" />
          </Button>
        </ButtonToolbar>
         <Grid id="sales_issue_credit-form" >
          <Row>
            <Col xs={12}>
              <h1><Translate value="issue_credit" /></h1>
            </Col>
          </Row>
          <Row>
            <Col xs={8}>
              <Panel>
                <Row>
                  <Col sm ={3}>
                    <Row>
                      <Col xs={12}>
                        <h3><Translate value="customer" /></h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={5}>
                        <label><Translate value="name" />:</label>
                      </Col>
                      <Col xs={7}>
                        {Customer_Name}
                      </Col>
                    </Row>

                  </Col>
                  <Col xs={6}>
                    <Row>
                      <Col xs={12}>
                        <h3><Translate value="invoice" /></h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={2}>
                        <label><Translate value="no" />:</label>
                      </Col>
                      <Col xs={7}>
                        {salesInvoiceDetail && salesInvoiceDetail.InvoiceNum}
                      </Col>
                    </Row>
                    {this.renderGGISales(salesInvoiceDetail)}
                  </Col>
                  <Col xs={3}>
                    <Row>
                      <Col xs={12}>
                        <h3><Translate value="return" /></h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={5}>
                        <label><Translate value="no" />:</label>
                      </Col>
                      <Col xs={7}>
                        {salesInvoiceDetail && salesInvoiceDetail.InvoiceNum}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={5}>
                        <label><Translate value="return_date" />:</label>
                      </Col>
                      <Col xs={7}>
                        <Field name="PostingDate" selected={moment().format("MM-DD-YY")} component={DatePicker} />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={5}>
                        <label><Translate value="user" />:</label>
                      </Col>
                      <Col xs={7}>
                        {salesInvoiceDetail && salesInvoiceDetail.Modifier_User_Name /*right?*/}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Panel>
            </Col>
            <Col xs={4}>
              <Panel>
                <Row>
                  <Col xs={12}>
                    <h3><Translate value="return_details" /></h3>
                  </Col>
                </Row>
                <Row>
                  <Col xs={2}>
                    <Row>
                      <Col xs={12}>
                        <label style={{'display': 'inline-flex'}}><Translate value="total" /><span className="dollar-sign"> $$</span>:</label>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Field name="ReturnTotal" component={DisabledInputField} placeholder={total}/>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={2}>
                    <Row>
                      <Col xs={12}>
                        <label><Translate value="crv" />:</label>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Field name="CRV" component={DisabledInputField} placeholder={CRV} />
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={2}>
                    <Row>
                      <Col xs={12}>
                        <label><Translate value="tax" />:</label>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Field name="Tax" component={DisabledInputField } placeholder={tax}/>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={3}>
                    <Row>
                      <Col xs={12}>
                        <label><Translate value="restock" />($):</label>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Input name="curRestock" type="number" onChange={this.handleRestock} value={this.state.curRestock} />
                      </Col>
                    </Row>
                  </Col>

                  {(isSDR || isCRW) &&
                    <Col xs={3}>
                      <Row>
                        <Col xs={12}>
                            <label><Translate value="restock" />(%):</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Input name="curRestockP" type="number" onChange={this.handleRestockP} value={this.state.curRestockP} />
                          </Col>
                      </Row>
                    </Col>
    }

                  <Col xs={2}>
                    <Row>
                      <Col xs={12}>
                        <label style={{'display': 'inline-flex'}}><Translate value="final" /><span className="dollar-sign"> $$</span>:</label>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Field name="FinalTotal" component={DisabledInputField} placeholder={finalPrice}/>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>

                <Col xs={8}>
                    <Row>
                      <Col xs={12}>
                        <label><Translate value="notation" />:</label>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Input name="curNotation" type="text" onChange={this.handleNotation} value={this.state.curNotation} />
                      </Col>
                    </Row>
                  </Col>

                </Row>
              </Panel>
            </Col>
          </Row>
          <span>
            <h2 style={{'marginTop': '0'}}><Translate value="product_information" /></h2>
          </span>
          <Panel>
          <Row>
            <Col xs={12}>
                <Row>
                  <Col xs={6}>
                    <Field name="searchType" component={ renderTypeRadios } />
                    <div style={{'padding-bottom':'9px'}}></div>
                    {/* <Field name="ProductInformation" component={InputField} ref="productSearch" withRef={true} onFocus={this.handleOnFocus} onKeyPress={(event) => {this.openShowInventory(event)}}/> */}
                    <IssueCreditAutoSuggest
                      SearchType={this.props.searchType}
                      onChange={(e, { newValue }) => {this.setState({ suggestValue: newValue })}}
                      value={this.state.suggestValue}
                      selectedCompany={this.props.selectedCompany}
                      selectInventoryInfo={this.selectInventoryInfo}
                      fetchItemSalesHistory={this.props.fetchItemSalesHistory}
                      currentCustomer_id={this.state.currentCustomer_id}
                    />
                  </Col>
                  <Col xs={ 6 } id="product-search-outputs">
                    <Col xs={ 2 } className="pr0">
                        <label ><Translate value="qty" /></label>
                        <Field name="Quantity" withRef={true} ref="quantity" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                              this.handleKeyPress(isGGI ?'smallUnitPrice' : 'unitPrice', event)
                          }} placeholder={I18n.t("must be > 0")}/>
                    </Col>
                    {this.renderUnitPrice()}
                    
                    <Col xs={ 2 }>
                      <label><Translate value="net_wt" /></label>
                        <Field name="Weight" withRef={true} ref="weight" component={ DisabledInputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                              if (event.charCode == 13) {
                                this.handleKeyPress('productSearch', event);
                                this.moveToIssueForm();
                              }
                            }}/>
                      </Col>
                      <Col xs={2}>
                        <Row>
                          <Col xs={ 12 }>
                            <label ><Translate value="subtotal" /></label>
                          </Col>
                            {this.renderSubtotal()}
                        </Row>
                      </Col>
                      {/* <Col xs={ 4 }>
                        <label><Translate value="notation" /></label>
                        <Field name="itemNotation" withRef={true} ref="notation" component={ InputField } onFocus={this.handleOnFocus} />
                      </Col> */}
                    </Col>
                  </Row>
                  {isOCM &&
                    <Row className="sale-history-details" style={{ 'margin-top': '0' }}>
                      <Col xs={12}>
                        <h4 style={{ marginBottom: '5px'}}><Translate value="sales_history" /></h4>
                        {this.renderItemHistory()}
                      </Col>
                    </Row>
                  }
              </Col>
            </Row>
          </Panel>
            <Row>
              <Col xs={12}>
                <Panel>
                  { this.renderInvoice() }
                </Panel>
              </Col>
            </Row>
        </Grid>

        <SkyLightStateless dialogStyles={createDialogStyleWeight} isVisible={this.state.ReturnModalOpen} onCloseClicked={() => { this.closeReturnModal(); }} title="Return Products">
          {/* <ReturnModal invoice setWeights={this.setWeights} keepLoaded={()=>{}} currentWeights={this.state.currentWeights} closeC={this.closeReturnModal} totalLoaded={2} rowChosen={this.state.rowChosen} returnTotalWeight={this.returnTotalWeight.bind(this)} /> */}
          <SetWeightModal invoice 
            setWeights={this.setWeights}
            keepLoaded={this.keepLoaded} 
            currentWeights={this.state.currentWeights} 
            closeC={this.closeReturnModal} 
            totalLoaded={this.state.totalLoaded} 
            rowChosen={this.state.rowChosen} 
            oldLoaded={this.state.oldQty}
            returnTotalWeight={this.returnTotalWeight.bind(this)} 
            editedRow={this.state.editedRow} />
        </SkyLightStateless>

        <SkyLightStateless dialogStyles={createDialogInventoryStyle} isVisible={this.state.showInventoryOpen} onCloseClicked={ ()=> {
            this.closeShowInventory('productSearch')}} title={selectInventoryInformation}>
            <SalesInventoryInfo
              Customer_id={this.state.currentCustomer_id}
              Company_id={this.props.selectedCompany ? this.props.selectedCompany.value : null}
              SearchType={this.props.searchType}
              SearchValue={this.props.searchValue}
              closeShowInventory={this.closeShowInventory}
              selectInventoryInfo={this.selectInventoryInfo}
              setSaleRowValue={this.props.setSaleRowValue}
              setAllProductQuantity={this.setAllProductQuantity}
              formName="customerIssueCredit"
            />
        </SkyLightStateless>
      </ContentWrapper>
    )
  }
}

let renderTypeRadios = props => {
    return (
      <div className="form-group" id="search-product-by">
          <label className="col-xs-4 search-by-max-width">
            <Translate value="search_by" />
          </label>
          {!isOLG && <label className="col-xs-2" >
              <input {...props.input} type="radio" value="ProductNum"
                checked={props.input.value === "ProductNum"}/>
              <Translate value="prod_num" />
          </label>}
          <label className="col-xs-2">
            <input {...props.input} type="radio" value="RefNum"
              checked={props.input.value === "RefNum"}/>
            <Translate value={isOLG ? "item_no" : "ref_num"} />
          </label>
          <label className="col-xs-2" >
              <input {...props.input} type="radio" value="Name"
                checked={props.input.value === "Name"}/>
              <Translate value="name" />
          </label>
          <label className="col-xs-2" >
              <input {...props.input} type="radio" value="Description"
                checked={props.input.value === "Description"}/>
              <Translate value="description" />
          </label>
      </div>
    )
}

export default CustomerIssueCredit;

function roundTo(n, digits) {
 if (digits === undefined) {
   digits = 0;
 }

 var multiplicator = Math.pow(10, digits);
 n = parseFloat((n * multiplicator).toFixed(11));
 var test =(Math.round(n) / multiplicator);
 return +(test.toFixed(2));
}



// WEBPACK FOOTER //
// ./master/jsx/components/Returns/customerIssueCredit.jsx